import { NgModule } from '@angular/core';

import { ProgressSpinnerModule } from '../components/core/progress-spinner/progress-spinner.module';

import { IfRoleDirective } from './if-role/if-role.directive';
import { LoadingDirective } from './loading/loading.directive';
import { TabViewScrollableDirective } from './tab-view-scrollable.directive';

@NgModule({
  declarations: [IfRoleDirective, LoadingDirective, TabViewScrollableDirective],
  exports: [IfRoleDirective, LoadingDirective, TabViewScrollableDirective],
  imports: [ProgressSpinnerModule],
})
export class SharedDirectiveModule {}
